import FingerprintJS from '@fingerprintjs/fingerprintjs';

const FP_KEY = 'device_fp';

export async function getDeviceFingerprint(): Promise<string> {
  const stored = localStorage.getItem(FP_KEY);
  if (stored) return stored;

  const fp = await FingerprintJS.load();
  const result = await fp.get();
  const visitorId = result.visitorId;
  localStorage.setItem(FP_KEY, visitorId);
  return visitorId;
}
